import { render, staticRenderFns } from "./omt-button.vue?vue&type=template&id=270a4a0a&scoped=true&"
import script from "./omt-button.vue?vue&type=script&lang=js&"
export * from "./omt-button.vue?vue&type=script&lang=js&"
import style0 from "./omt-button.vue?vue&type=style&index=0&id=270a4a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a4a0a",
  null
  
)

export default component.exports